export const getHost = () => window.location.host;

export const isLocalhost = () => {

  const host = getHost();
  return host.match(/^localhost:/gi) || host.match(/^127.0.0.1:/gi) || host.match(/^18.223.159.40:/gi)
};
